module.exports = __webpack_public_path__ + "img/img34.092a76c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img34.jpg
// module id = 332
// module chunks = 0